// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CognitionSection-module__rows___K_ZTe {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.CognitionSection-module__row___YHcsU {
  display: grid;
  grid-template-columns: 48px 70px 52px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #3f3f46;
}

.CognitionSection-module__test___Q9KZh {
  font-weight: 600;
  color: #18181b;
}

.CognitionSection-module__date___doKtC {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #71717a;
}

.CognitionSection-module__score___YQQFI {
  font-variant-numeric: tabular-nums;
  color: #18181b;
}

.CognitionSection-module__actions___I6ldn {
  display: inline-flex;
  gap: 8px;
}

.CognitionSection-module__actionButton___adGq1 {
  display: inline-flex;
  white-space: nowrap;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  text-decoration: none;
  cursor: pointer;
}
.CognitionSection-module__actionButton___adGq1:hover:not(:disabled) {
  border-color: #18181b;
  color: #18181b;
}
.CognitionSection-module__actionButton___adGq1:disabled {
  color: #a1a1aa;
  cursor: default;
}

.CognitionSection-module__actionIcon___lOeDV {
  color: #71717a;
}

.CognitionSection-module__error___PyV2l {
  margin: 0;
  font-size: 13px;
  color: #b91c1c;
}

.CognitionSection-module__empty___Sw2NG {
  margin: 0;
  padding-top: 6px;
  font-size: 14px;
  color: #a1a1aa;
}

@container (max-width: 639px) {
  .CognitionSection-module__rows___K_ZTe {
    gap: 0;
  }
  .CognitionSection-module__row___YHcsU {
    grid-template-columns: 44px 62px 48px minmax(0, 1fr);
    gap: 8px;
    padding: 10px 0;
    border-top: 1px solid #f4f4f5;
  }
  .CognitionSection-module__row___YHcsU:first-child {
    padding-top: 0;
    border-top: none;
  }
  .CognitionSection-module__actions___I6ldn {
    grid-column: 1/-1;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/CognitionSection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,yDAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kCAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAGA;EACE;IACE,MAAA;EAAF;EAGA;IACE,oDAAA;IACA,QAAA;IACA,eAAA;IACA,6BAAA;EADF;EAGE;IACE,cAAA;IACA,gBAAA;EADJ;EAKA;IACE,iBAAA;IACA,eAAA;EAHF;AACF","sourcesContent":[".rows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 48px 70px 52px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.test {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.date {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.score {\n  font-variant-numeric: tabular-nums;\n  color: #18181b;\n}\n\n.actions {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.actionButton {\n  display: inline-flex;\n  white-space: nowrap;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #18181b;\n    color: #18181b;\n  }\n\n  &:disabled {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n\n.actionIcon {\n  color: #71717a;\n}\n\n.error {\n  margin: 0;\n  font-size: 13px;\n  color: #b91c1c;\n}\n\n.empty {\n  margin: 0;\n  padding-top: 6px;\n  font-size: 14px;\n  color: #a1a1aa;\n}\n@container (max-width: 639px) {\n  .rows {\n    gap: 0;\n  }\n\n  .row {\n    grid-template-columns: 44px 62px 48px minmax(0, 1fr);\n    gap: 8px;\n    padding: 10px 0;\n    border-top: 1px solid #f4f4f5;\n\n    &:first-child {\n      padding-top: 0;\n      border-top: none;\n    }\n  }\n\n  .actions {\n    grid-column: 1 / -1;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rows": `CognitionSection-module__rows___K_ZTe`,
	"row": `CognitionSection-module__row___YHcsU`,
	"test": `CognitionSection-module__test___Q9KZh`,
	"date": `CognitionSection-module__date___doKtC`,
	"score": `CognitionSection-module__score___YQQFI`,
	"actions": `CognitionSection-module__actions___I6ldn`,
	"actionButton": `CognitionSection-module__actionButton___adGq1`,
	"actionIcon": `CognitionSection-module__actionIcon___lOeDV`,
	"error": `CognitionSection-module__error___PyV2l`,
	"empty": `CognitionSection-module__empty___Sw2NG`
};
module.exports = ___CSS_LOADER_EXPORT___;
